import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const singlesTrainingLocalGameRoutes: Route[] = [
    {
        path: 'local-games/singles-training',
        loadComponent: () =>
            import('./pages/singles-training-new-game/singles-training-new-game.component').then(
                (c) => c.SinglesTrainingNewGameComponent
            ),
    },
    {
        path: 'game/singles-training',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/singles-training-local-game-app/singles-training-local-game-app.component').then(
                (m) => m.SinglesTrainingLocalGameAppComponent
            ),
    },
];

export const singlesTrainingVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/singles-training',
        loadComponent: () =>
            import('./pages/singles-training-new-game/singles-training-new-game.component').then(
                (c) => c.SinglesTrainingNewGameComponent
            ),
    },
    {
        path: 'game/singles-training',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/singles-training-local-game-venue/singles-training-local-game-venue.component').then(
                (m) => m.SinglesTrainingLocalGameVenueComponent
            ),
    },
];
